import React, { Component } from 'react';
import Proptypes from 'prop-types';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';

const styles = theme =>({
  root: {
    flex: '1 0 100%',
    margin: theme.spacing.unit,
    height: '100%'
  },
  section: {
    padding: 16,
    marginTop: theme.spacing.unit * 3,
  },
  super: {
    verticalAlign: 'super',
    fontSize: '0.25em'
  },
  headline: {
    color: theme.palette.primary.main
  },
  a: {
    whiteSpace : 'nowrap'
  }
});

export class SupportPage extends Component{
  render(){
    const { classes } = this.props;

    return (
      <div data-title="Support" className={classes.root}>
        <Paper>
          <div className={classes.section}>
            <Typography variant="headline" className={classes.headline} paragraph={true}>
              Have Questions?
            </Typography>
            <Typography variant="headline" className={classes.headline} paragraph={true}>
              Email us at{' '}
              <a href="mailto:stackup-design.support@iteq.com.tw">stackup-design.support@iteq.com.tw</a>
            </Typography>
          </div>
        </Paper>
      </div>
    );
  }
}

SupportPage.proptypes = {
  classes: Proptypes.object.isrequired,
  classname: Proptypes.string,
}

export default withStyles(styles)(SupportPage);



// WEBPACK FOOTER //
// ./src/components/SupportPage/index.js